import { render, staticRenderFns } from "./EventControlPanelExtensionDialog.vue?vue&type=template&id=243cebb0&scoped=true&"
import script from "./EventControlPanelExtensionDialog.vue?vue&type=script&lang=js&"
export * from "./EventControlPanelExtensionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243cebb0",
  null
  
)

export default component.exports